export const integrationsAuth = {
  google: {
    connectionUrl: () => {
      const url = new URL('https://api.us.nylas.com/v3/connect/auth');
      url.searchParams.append('client_id', `${process.env.VITE_NYLAS_CLIENT_ID}`);
      url.searchParams.append('response_type', 'code');
      url.searchParams.append('redirect_uri', window.origin + '/auth/google');
      url.searchParams.append('provider', 'google');
      url.searchParams.append('access_type', 'online');
      return url.toString();
    },
    codeParam: 'code',
    redirectUrl: window.origin + '/auth/google'
  },
  microsoft: {
    connectionUrl: () => {
      const url = new URL('https://api.us.nylas.com/v3/connect/auth');
      url.searchParams.append('client_id', `${process.env.VITE_NYLAS_CLIENT_ID}`);
      url.searchParams.append('response_type', 'code');
      url.searchParams.append('redirect_uri', window.origin + '/auth/microsoft');
      url.searchParams.append('provider', 'microsoft');
      url.searchParams.append('access_type', 'online');

      return url.toString();
    },
    codeParam: 'code',
    redirectUrl: window.origin + '/auth/microsoft'
  }
};
